import { render, staticRenderFns } from "./editEquipmentAccountList.vue?vue&type=template&id=87c47c7e&scoped=true"
import script from "./editEquipmentAccountList.vue?vue&type=script&lang=js"
export * from "./editEquipmentAccountList.vue?vue&type=script&lang=js"
import style0 from "./editEquipmentAccountList.vue?vue&type=style&index=0&id=87c47c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c47c7e",
  null
  
)

export default component.exports